import {
  SET_CONSTRAINTS,
  SET_MAX_BANDWIDTH,
  SET_CODEC,
  SET_SIMULCAST,
  CLEAR_MEDIA
} from '@/store/mutation-types'
import Constraints from '@/models/constraints'
import localStorageService from '@/services/localStorage'
// import * as _ from 'ramda'
import l from '@/vendor/logger'

const state = {
  constraints: {
    ...Constraints()
  },
  maxBandwidth: null,
  codec: null,
  simulcast: null
}

const getters = {
}

const mutations = {
  [SET_CONSTRAINTS] (state, constraints) {
    // TODO: constraints support check
    // Object.keys(constraints.video).concat(Object.keys(constraints.audio)
    // navigator.mediaDevices.getSupportedConstraints()
    state.constraints = constraints
  },
  [SET_MAX_BANDWIDTH] (state, maxBandwidth) {
    state.maxBandwidth = maxBandwidth
  },
  [SET_CODEC] (state, codec) {
    state.codec = codec
  },
  [SET_SIMULCAST] (state, simulcast) {
    state.simulcast = simulcast
  },
  [CLEAR_MEDIA] (state) {
    state.constraints = Constraints()
    state.maxBandwidth = null
    state.codec = null
    state.simulcast = null
  }
}

const actions = {
  saveSettings ({ state }) {
    l.d('media/saveSettings', state)
    localStorageService.save('media', state)
  },

  loadSettings ({ commit }) {
    if (localStorageService.isExist('media')) {
      const fromLocalStorage = localStorageService.load('media')
      commit(SET_CONSTRAINTS, fromLocalStorage.constraints)
      commit(SET_MAX_BANDWIDTH, fromLocalStorage.maxBandwidth)
      commit(SET_CODEC, fromLocalStorage.codec)
      localStorageService.remove('media')
      l.d('media/loadSettings', fromLocalStorage)
    } else {
      l.d('media/loadSettings/not_exist')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
